export default __webpack_public_path__ + "static/media/error.d6f1938b.svg";